import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * Named cell template, replacing DevExtreme's `cellTemplate="fooCell"` +
 * `<div *dxTemplate="let cell of 'fooCell'">` pair (317 column templates and
 * 323 dxTemplate blocks across the app).
 *
 *   <ng-template appGridCell="statusCell" let-row let-value="value" let-column="column">
 *     <nz-tag [nzColor]="row.active ? 'green' : 'red'">{{ value }}</nz-tag>
 *   </ng-template>
 *
 * `let-row` is the whole data row, matching what DevExtreme passes as
 * `cell.data` - the property most existing templates actually read.
 */
@Directive({ selector: '[appGridCell]', standalone: false })
export class DataGridCellDirective {
  @Input('appGridCell') name!: string;
  constructor(public template: TemplateRef<any>) { }
}

/** Header-cell equivalent of the above (`headerCellTemplate`). */
@Directive({ selector: '[appGridHeaderCell]', standalone: false })
export class DataGridHeaderCellDirective {
  @Input('appGridHeaderCell') name!: string;
  constructor(public template: TemplateRef<any>) { }
}

/**
 * Expandable detail row, replacing `<dxo-master-detail [enabled]="true"
 * template="detail">` (11 grids).
 *
 *   <ng-template appGridDetail let-row>
 *     <app-trip-detail [tripId]="row.trip_id"></app-trip-detail>
 *   </ng-template>
 */
@Directive({ selector: '[appGridDetail]', standalone: false })
export class DataGridDetailDirective {
  constructor(public template: TemplateRef<any>) { }
}
